import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
export const Testimonials = () => {
  const reviews = [{
    name: 'Valentina M.',
    handle: '@valen.candles',
    highlight: 'Ya superé mi sueldo del trabajo que dejé.',
    text: 'Empecé con miedo y sin saber nada. A los 3 meses ya tenía mi propia marca.',
    img: 'https://i.pravatar.cc/150?img=44'
  }, {
    name: 'Sofía R.',
    handle: '@sofia_aesthetic',
    highlight: 'Vendí mi primer lote en 48 horas.',
    text: 'El módulo de Instagram es ORO. Pasé de 0 seguidoras a clientas reales rapidísimo.',
    img: 'https://i.pravatar.cc/150?img=45'
  }, {
    name: 'Camila T.',
    handle: '@luz.cozy',
    highlight: 'Por fin un curso que se siente premium.',
    text: 'Te enseñan a crear una marca, no solo manualidades. Mis clientas aman el packaging.',
    img: 'https://i.pravatar.cc/150?img=49'
  }];
  return <section className="py-24 bg-white" data-id="element-202">
      <div className="max-w-6xl mx-auto px-6" data-id="element-203">
        <FadeIn className="text-center mb-16" data-id="element-204">
          <span className="inline-block text-sm font-semibold tracking-widest uppercase text-accent-rose-deep mb-4" data-id="element-205">
            +2.500 alumnas
          </span>
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-206">Historias Reales</h2>
          <p className="text-lg text-text-brown/70" data-id="element-207">
            Mujeres viviendo de su emprendimiento.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-208">
          {reviews.map((review, i) => <FadeIn key={i} delay={i * 0.1} direction="up" className="bg-cream p-8 rounded-3xl border border-nude shadow-sm relative" data-id="element-209">
              <Quote className="w-8 h-8 text-accent-rose/40 absolute top-6 right-6" data-id="element-210" />

              <div className="flex text-gold-soft mb-4" data-id="element-211">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-212" />)}
              </div>

              <p className="text-lg font-serif font-bold text-text-dark mb-3 leading-snug" data-id="element-213">
                "{review.highlight}"
              </p>
              <p className="text-sm text-text-brown/80 mb-6 leading-relaxed" data-id="element-214">
                {review.text}
              </p>

              <div className="flex items-center gap-4 pt-4 border-t border-nude" data-id="element-215">
                <img src={review.img} alt={review.name} className="w-12 h-12 rounded-full object-cover" data-id="element-216" />
                <div data-id="element-217">
                  <h4 className="font-bold text-text-dark text-sm" data-id="element-218">
                    {review.name}
                  </h4>
                  <span className="text-xs text-text-brown/60" data-id="element-219">
                    {review.handle}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};